import logo from '~assets/logo-ticsocial.svg';
import './TicsocialWatermark.scss';

const TicsocialWatermark = () => {
  return (
    <div className="ticsocial_watermark">
      <div className="d-flex align-items-center gap-5">
        <img src={logo} alt="logo ticsocial" />
      </div>
    </div>
  );
};

export default TicsocialWatermark;
